import { TFunction } from "i18next";
import { Text } from "@pentabd/ui";

export const DetailsColumn = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 2,
      key: "id",
      name: "ক্র: নং",
      render: (id: number) => (
        <Text color="subtitle1" className="text-nowrap">
          {id}
        </Text>
      ),
    },
    {
      id: 3,
      key: "unitName",
      name: "ইউনিটের নাম",
      render: (unitName: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {unitName}
        </Text>
      ),
    },
    {
      id: 4,
      key: "employeeCode",
      name: "আইডি নম্বর",
      render: (employeeCode: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {employeeCode}
        </Text>
      ),
    },

    {
      id: 5,
      key: "nameBn",
      name: "কর্মকর্তা/কর্মচারীর নাম",
      render: (nameBn: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {nameBn}
        </Text>
      ),
    },
    {
      id: 5,
      key: "positionNameBn",
      name: "পদবি",
      render: (positionNameBn: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {positionNameBn}
        </Text>
      ),
    },
    {
      id: 6,
      key: "joiningDate",
      name: "চাকুরীতে যোগদানের তারিখ",
      render: (joiningDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {joiningDate}
        </Text>
      ),
    },
    {
      id: 7,
      key: "currentPositionJoiningDate",
      name: "বর্তমান পদে যোগদানের তারিখ",
      render: (currentPositionJoiningDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {currentPositionJoiningDate}
        </Text>
      ),
    },
    {
      id: 8,
      key: "currentPlaceJoiningDate",
      name: "বর্তমান কর্মস্থলে যোগদানের তারিখ",
      render: (currentPlaceJoiningDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {currentPlaceJoiningDate}
        </Text>
      ),
    },
    {
      id: 9,
      key: "duration",
      name: "বর্তমান কর্মস্থলের মেয়াদ",
      render: (duration: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {duration}
        </Text>
      ),
    },
    {
      id: 10,
      key: "previousOfficeNameAndDuration",
      name: "পূর্ববর্তী কর্মস্থলের নাম ও সময়কাল",
      render: (previousOfficeNameAndDuration: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {previousOfficeNameAndDuration}
        </Text>
      ),
    },
    {
      id: 11,
      key: "dateOfBirth",
      name: "জন্ম তারিখ",
      render: (dateOfBirth: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {dateOfBirth}
        </Text>
      ),
    },
    {
      id: 12,
      key: "prlDate",
      name: "পি আর এল গমনের তারিখ",
      render: (prlDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {prlDate}
        </Text>
      ),
    },
    {
      id: 13,
      key: "homeDistrict",
      name: "নিজ জেলা",
      render: (homeDistrict: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {homeDistrict}
        </Text>
      ),
    },
    {
      id: 14,
      key: "homeDistrict",
      name: "মন্তব্য",
      render: () => <Text color="subtitle1" className="text-nowrap"></Text>,
    },
  ];
};
